// extracted by mini-css-extract-plugin
module.exports = {"page-container":"page-base_layout_page-container__48COA","page-main":"page-base_layout_page-main__COu_r"};